import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IDeliveredShort } from "../models/dsException";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 */

export const GetDeliveredShortAPI = async (osdNumber: number | string): Promise<IDeliveredShort> => {
  try {
    const response = await axios.get(`${getUrl(ApiType.DS_ENTRY_DETAILS)}/${osdNumber}`);
    return response?.data ?? {};
  } catch (error) {
    return throwApiError(error, ErrorMessages.dSEntryDetailsAPIError, { badRequestOrder: "errorsFirst" });
  }
};
